export const prepareComparisonData = (comparison_sections, values_for_compare) => {
  const sectionsAlias = Object.keys(comparison_sections.items);
  const values = Object.values(values_for_compare.items).map((item) => ({
    ...item.form_data,
    alias: item.alias,
    id: item.id,
  }));
  return sectionsAlias.map((section) => ({
    section: comparison_sections.items[section],
    values: values.filter((item) => item.section === section),
  }));
};
